export const COMPATIBLE_BACKEND_API_VERSIONS = ['^2.1.0'];

export default COMPATIBLE_BACKEND_API_VERSIONS;
